import * as Font from 'expo-font';
import Fonts from 'src/core/utils/Fonts';
import { useState, useEffect } from 'react';
import { useAuthStore } from 'src/domain/stores/useAuthStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import barlowBold from 'assets/fonts/Barlow-Bold.ttf';
import barlowItalic from 'assets/fonts/Barlow-Italic.ttf';
import barlowMedium from 'assets/fonts/Barlow-Medium.ttf';
import barlowRegular from 'assets/fonts/Barlow-Regular.ttf';
import code128 from 'assets/fonts/code128.ttf';
import ean13 from 'assets/fonts/ean13.ttf';
import ptSerifRegular from 'assets/fonts/PTSerif-Regular.ttf';
import type ApiRequestError from 'src/core/models/api/ApiRequestError';

export default function useCachedResources() {
	const [isLoadingComplete, setLoadingComplete] = useState(false);
	const { init: initAuthStore } = useAuthStore();

	useEffect(() => {
		const loadResourcesAndDataAsync = async () => {
			await initAuthStore();

			await Font.loadAsync({
				[Fonts.ptSerif]: ptSerifRegular,
				[Fonts.barlow]: barlowRegular,
				[Fonts.barlowMedium]: barlowMedium,
				[Fonts.barlowBold]: barlowBold,
				[Fonts.barlowItalic]: barlowItalic,
				[Fonts.code128]: code128,
				[Fonts.ean13]: ean13,
			});
		};

		loadResourcesAndDataAsync()
			.catch((error: ApiRequestError) =>
				useServicesStore.getState().captureEvent({ message: 'useCachedResources failed', extra: { error } }),
			)
			.finally(() => setLoadingComplete(true));
	}, [initAuthStore]);

	return isLoadingComplete;
}
